import axios from "../utils/axios";

export async function resetPassword(
  email: string,
  password: string,
  resetToken: string
): Promise<void> {
  await axios.patch(`/user/password/reset/`, { email, resetToken, password });
}

export async function createAccount(
  email: string,
  password: string,
  inviteId: string,
  firstName: string,
  lastName: string,
  dateFormat: any,
  timeZone: any,
  timeFormat: any,
  state: any
): Promise<void> {
  await axios.post(`/oauth/user`, {
    email,
    password,
    inviteId,
    firstName,
    lastName,
    dateFormat,
    timeZone,
    timeFormat,
    state,
  });
}

export async function resendEmailVerificationEmail(
  email: string,
  clientId: string,
  redirectUri: string
): Promise<void> {
  await axios.post(`/user/email/verify`, {
    email,
    clientId,
    redirectUri,
  });
}

export async function getcreateAccountInfo(inviteID: string): Promise<any> {
  try {
    const res = await axios.get(`user/invite/${inviteID}`);
    return res.data;
  } catch (error) {
    return null;
  }
}

export const requestReactivateAccount = async (
  token: string,
  email: string
): Promise<void> => axios.post(`/oauth/reactivate`, { token, email });
